// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class DataStream {
    constructor(onMessageDelegate) {
        if (onMessageDelegate && onMessageDelegate !== null) {
            this.OnMessageDelegate = onMessageDelegate;
        }
        else {
            this.OnMessageDelegate = null;
        }
    }
}
